import React, { Component } from 'react';
import {
   Col, Card, CardBody, Table, Button, Row,
} from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import Moment from 'moment';
import CalendarIcon from 'mdi-react/CalendarIcon';
import DatePicker from 'react-datepicker';
import AsyncSelect from 'react-select/lib/Async';
import SelectService from '../../../services/SelectService';
import CommonService from '../../../services/CommonService';
import global from '../../../global';

class RemitReport extends Component {
   constructor() {
      super();
      this.state = {
         list: [],
         formdata: {
            locationId: '',
         },
         totalRemit: 0,
         goTo: false,
         lastPageVisited: window.history.state !== null ? window.history.state.state.prevpage : '',
      };
      this.userdata = JSON.parse(localStorage.getItem('userData'));
      this.searchTransaction = this.searchTransaction.bind(this);
   }

   componentDidMount() {
      this.isLoading = true;
      this.loadProfitTable();
   }

   loadProfitTable = async (inventoryDate = '', locationID = '') => {
      try {
         const invDate = inventoryDate !== '' ? inventoryDate : Moment(new Date()).format('YYYY-MM-DD');
         const locID = locationID !== '' ? `/locationid/${locationID}` : '';

         const response = await CommonService.getRows(`remitreportlist/inventorydate/${invDate}${locID}`);
         if (response) {
            this.setState({ list: response.list, totalRemit: response.overall_remit });
         }
      } catch (err) {
         console.log('Error: ', err.message);
         this.isLoading = false;
      }
   }

   goBack = () => {
      this.setState({ goTo: true });
   }

   getLocations = async (newValue) => {
      this.isLoading = true;
      const formData = { searchFor: newValue, searchType: 9 };
      const options = [];
      if (this.isLoading) {
        await SelectService.listLocationOptions(formData).then((response) => {
          if (response) {
            response.map(opt => (
              options.push({
                value: opt.location_id,
                label: opt.location_name,
              })
            ));
          }
        }).catch((error) => {
          console.log('Error: ', error.message);
        });
        this.isLoading = false;
      }

      return options;
    }

   getProducts = async (newValue) => {
      this.isLoading = true;
      const formData = { searchFor: newValue };
      const options = [];
      if (this.isLoading) {
        await SelectService.listProductOptions(formData).then((response) => {
          if (response) {
            response.map(opt => (
              options.push({
                value: opt.product_id,
                label: opt.product_name,
              })
            ));
          }
        }).catch((error) => {
          console.log('Error: ', error.message);
        });
        this.isLoading = false;
      }

      return options;
    }

   handleChange = (e, fieldName) => {
      if (fieldName === 'fromDate') {
       const date = new Date(e);
       this.setState(prevState => ({
         formdata: {
           ...prevState.formdata,
           fromDate: date,
         },
       }));
     } else if (fieldName === 'inventoryDate') {
       const date = new Date(e);
       this.setState(prevState => ({
         formdata: {
           ...prevState.formdata,
           inventoryDate: date,
         },
       }));
     } else if (fieldName === 'locationid') {
         let locationId = '';
         if (e) {
            locationId = e.value;
         }

         this.setState(prevState => ({
           formdata: { ...prevState.formdata, locationId },
         }));
     } else {
       const { name, value } = e.target;
       this.setState(prevState => ({
         formdata: { ...prevState.formdata, [name]: value },
       }));
     }
   }

   searchTransaction(e) {
      e.preventDefault();
      const { formdata } = this.state;
      const inventoryDate = Moment(formdata.inventoryDate).format('YYYY-MM-DD');
      this.loadProfitTable(inventoryDate, formdata.locationId);
   }

   render() {
      const {
         list, goTo, lastPageVisited, formdata, totalRemit,
      } = this.state;

      if (goTo === true) {
         return <Redirect to={{ pathname: lastPageVisited }} />;
      }

      if (this.userdata.type !== '1') {
         return <Redirect to="/dashboard" />;
      }

      // to date
      let inventoryDate = new Date();
      if (formdata.inventoryDate) {
        inventoryDate = new Date(formdata.inventoryDate);
      }

      return (
         <Col md={12}>
            <Card className="panel panel--primary" id="users_table">
               <CardBody className="panel__body">
                  <div className="panel__title bg_blue">
                     <h5 className="bold-text">Remit Table</h5>
                     <div className="panel__btns">
                     {
                        lastPageVisited !== '' ? (
                           <Button onClick={this.goBack} className="rounded text-white btn btn-sm btn-outline-secondary btn-awesome" size="sm" outline>
                           <i className="fa fa-arrow-left" />
                           <span>Back</span>
                           </Button>
                        ) : ''
                     }
                     </div>
                  </div>
                  <Row className="m-0">
                     <Col md={12} className="m-b-20">
                        <form className="form form--horizontal the_form_display" onSubmit={this.searchTransaction}>
                           <div className="form__form-group m-b-7">
                              <div className="form__form-group-field m-l-0">
                                 <span className="form__form-group-label text-right m-r-10 mw-65 xw-65">Location:</span>
                                 <div className="form__form-group-icon mh-38">
                                    <CalendarIcon />
                                 </div>
                                 <AsyncSelect
                                    name="locationid"
                                    cacheOptions
                                    loadOptions={this.getLocations}
                                    defaultOptions
                                    isClearable
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    placeholder="Location name..."
                                    onChange={e => this.handleChange(e, 'locationid')}
                                 />
                              </div>
                           </div>
                           <div className="form__form-group m-b-7">
                              <div className="form__form-group-field m-l-0">
                                 <span className="form__form-group-label text-right m-r-10 mw-30 xw-30">Date:</span>
                                 <div className="form__form-group-icon">
                                    <CalendarIcon />
                                 </div>
                                 <DatePicker
                                    name="inventoryDate"
                                    selected={inventoryDate}
                                    popperPlacement="top-end"
                                    onChange={e => this.handleChange(e, 'inventoryDate')}
                                 />
                                 <button type="submit" className="form__form-group-button bg-primary">Search</button>
                              </div>
                           </div>
                        </form>
                     </Col>
                  </Row>
                  <div className="panel__content">
                  <h3>Total Remits: {totalRemit <= 0 ? <span className="text-red">&#x20B1; {global.numberFormat(totalRemit)}</span> : <span className="text-green">&#x20B1; {global.numberFormat(totalRemit)}</span>}</h3>
                  <Table responsive striped className="table-blue head-center">
                     <thead className="th-vtop">
                        <tr>
                           <th rowSpan="2" className="v-bottom">Location</th>
                           <th colSpan="3" className="text-center bg-orange">To Remit</th>
                           <th colSpan="3" className="text-center bg-green">Total Remitted</th>
                           <th colSpan="3" className="text-center bg-red">Variance</th>
                        </tr>
                        <tr>
                           <th>Cash</th>
                           <th>Cheque</th>
                           <th>Total</th>

                           <th>Cash</th>
                           <th>Cheque</th>
                           <th>Total</th>

                           <th>Cash</th>
                           <th>Cheque</th>
                           <th>Total</th>
                        </tr>
                     </thead>
                     <tbody>
                        {
                           list.length > 0 ? list.map((item) => {
                               const toremitCash = item.toremit_cash === '' ? 0 : global.parseToNumber(item.toremit_cash);
                               const toremitCheque = item.toremit_cheque === '' ? 0 : global.parseToNumber(item.toremit_cheque);
                               const toremitTotal = item.toremit_total === '' ? 0 : global.parseToNumber(item.toremit_total);

                               const remitCash = item.remit_cash === '' ? 0 : global.parseToNumber(item.remit_cash);
                               const remitCheque = item.remit_cheque === '' ? 0 : global.parseToNumber(item.remit_cheque);
                               const remitTotal = item.remit_total === '' ? 0 : global.parseToNumber(item.remit_total);

                               const varCash = item.var_cash === '' ? 0 : global.parseToNumber(item.var_cash);
                               const varCheque = item.var_cheque === '' ? 0 : global.parseToNumber(item.var_cheque);
                               const varTotal = item.var_total === '' ? 0 : global.parseToNumber(item.var_total);

                                return (
                                 <tr key={item.daily_report_id} className="text-center">
                                    <td className="text-left">{item.location_name}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(toremitCash)}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(toremitCheque)}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(toremitTotal)}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(remitCash)}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(remitCheque)}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(remitTotal)}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(varCash)}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(varCheque)}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(varTotal)}</td>
                                 </tr>
                              );
                           }) : (
                              <tr className="text-center">
                                 <td colSpan="9">No data available..</td>
                              </tr>
                           )
                        }
                     </tbody>
                  </Table>
                  </div>
               </CardBody>
            </Card>
         </Col>
      );
   }
}

export default withTranslation('common')(RemitReport);
